export default __webpack_public_path__ + "static/media/photo--sm--wheel-7.ba5080df.jpg";